import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';

export interface BannerDto {
  id: string;
  // New documented field names (per backend spec)
  title: string;
  description: string;
  imageUrl: string;
  linkUrl?: string;
  isActive: boolean;
  displayOrder?: number;
  criadoEm?: string;
  atualizadoEm?: string;
  // Legacy fields (for backward compatibility - will be deprecated)
  nome?: string;
  localizacao?: string;
  linkDestino?: string;
  order?: number;
  ativo?: boolean;
  dataInicio?: string;
  dataExpiracao?: string;
  createdAt?: string;
  updatedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class BannerService {
  constructor(private api: ApiService) {}

  list(page = 1, pageSize = 20): Observable<any> {
    return this.api.get('/admin/banners', { page, pageSize }) as Observable<any>;
  }

  getById(id: string): Observable<BannerDto> {
    return this.api.get(`/admin/banners/${id}`) as Observable<BannerDto>;
  }

  create(payload: Partial<BannerDto>): Observable<any> {
    return this.api.post('/admin/banners', payload);
  }

  update(id: string, payload: Partial<BannerDto>): Observable<any> {
    return this.api.put(`/admin/banners/${id}`, payload);
  }

  delete(id: string): Observable<any> {
    return this.api.delete(`/admin/banners/${id}`);
  }

  toggleActive(id: string): Observable<any> {
    return this.api.patch(`/admin/banners/${id}/toggle-active`, {});
  }

  reorder(bannerIds: string[]): Observable<any> {
    return this.api.post('/admin/banners/reorder', { bannerIds });
  }
}
